import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import NotebookSection from "./components/NotebookSection";
import FeaturesSection from "./components/FeaturesSection";
import IntegrationSection from "./components/IntegrationSection";
import UseCasesSection from "./components/UseCasesSection";
import TechSection from "./components/TechSection";
import DemoForm from "./components/DemoForm";
import Footer from "./components/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <NotebookSection />
        <FeaturesSection />
        <IntegrationSection />
        <UseCasesSection />
        <TechSection />
        <DemoForm />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
